import { defineMessages } from 'react-intl';

export const MODELS_MESSAGES = defineMessages({
  improvedButton: {
    id: 'asicModels.improvedButton',
    defaultMessage: 'Improved'
  },
  standardButton: {
    id: 'asicModels.standardButton',
    defaultMessage: 'Standard'
  },
  downloadButton: {
    id: 'asicModels.downloadButton',
    defaultMessage: 'Download'
  },
  s17Option1: {
    id: 'asicModels.s17Option1',
    defaultMessage: '{hashrate} with Air Cooling'
  },
  s17Option2: {
    id: 'asicModels.s17Option2',
    defaultMessage: '{hashrate} w/ Standard PSU'
  },
  s17Option3: {
    id: 'asicModels.s17Option3',
    defaultMessage: '{hashrate} w/ Liquid Cooling',
  },
  s17Footer: {
    id: 'asicModels.s17Footer',
    defaultMessage: 'High Protection From Viruses!'
  },
  t17Option1: {
    id: 'asicModels.t17Option1',
    defaultMessage: '{hashrate} with standard PSU'
  },
  t17Option2: {
    id: 'asicModels.t17Option2',
    defaultMessage: '{hashrate} with liquid cooling'
  },
  t17Footer: {
    id: 'asicModels.t17Footer',
    defaultMessage: 'Increased performance, Better Stability'
  },
  l3Option1: {
    id: 'asicModels.l3Option1',
    defaultMessage: '{hashrate} with standard PSU',
  },
  l3Option2: {
    id: 'asicModels.l3Option2',
    defaultMessage: 'Fast and easy start, no overheating, stable mining'
  },
  s10Option1: {
    id: 'asicModels.s10Option1',
    defaultMessage: '{hashrate} with standard PSU on S9'
  },
  s10Option2: {
    id: 'asicModels.s10Option2',
    defaultMessage: '{hashrate} with custom PSU connected'
  },
  s10Footer: {
    id: 'asicModels.s10Footer',
    defaultMessage: 'Lower consumption, higher hashrate!'
  },
  s9Option1: {
    id: 'asicModels.s9Option1',
    defaultMessage: '{hashrate} with standard PSU on S9'
  },
  s9Option2: {
    id: 'asicModels.s9Option2',
    defaultMessage: '{hashrate} with custom PSU connected'
  },
  t9Option1: {
    id: 'asicModels.t9Option1',
    defaultMessage: '{hashrate} with standard PSU'
  },
  t9Option2: {
    id: 'asicModels.t9Option2',
    defaultMessage: 'Compared to the 10.5Th/s on the stock firmware'
  },
});
